//デザインタブ-アイテムタブ (template/common 共通)
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';
import { List, ListItem, ListItemText, ListItemIcon, Box } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

import { CardAttributeDbHashType } from '../redux/cardAttributeDbSlice';
import { deepCopy } from '../general';
import { EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType } from '../components/EditTemplateDialog';
import { EditUiCardItemDbHashType, EditCardShapeDbHashType } from '../components/EditDialog';

type ItemListItemProps = {
  dragging: boolean;
}
const ItemListItem = styled(ListItem)<ItemListItemProps>`
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  transition: ${props => props.dragging ? undefined : '300ms'};
`

//デザインタブ-アイテムタブ
type SelectItemNameProps = {
  ids: string[];
  attributes: EditTemplateAttributeDbHashType | CardAttributeDbHashType | EditUiCardItemDbHashType;
  shapes?: EditTemplateShapeDbHashType | EditCardShapeDbHashType;
  selectingId: string | undefined;
  setSelectingId: (id: string | undefined) => void;
  changeItemZ: (dropZ: number) => void;
  openDetailTab: () => void;
}
const SelectItemName: React.FC<SelectItemNameProps> = ({ ids, attributes, shapes, selectingId, setSelectingId, changeItemZ, openDetailTab }) => {
  type ListItemType = { name: string; z: number; }
  type ListHash = { [key in string]: ListItemType }
  const [list, setList] = useState<ListHash>({});
  const [draggingId, setDraggingId] = useState('');

  useEffect(() => {
    const newList: ListHash = {};
    ids.forEach(id => {
      const item = attributes[id] || (shapes ? shapes[id] : null);
      if (!item) return;
      newList[id] = { name: item.name, z: item.z };
    })
    setList(newList);
  }, [attributes, shapes])

  const handleDragStart = (id: string) => {
    setSelectingId(id);
    setDraggingId(id);
  }
  const changeZExe = (data: DraggableData) => {
    setDraggingId('');
    const dropZ = Math.round(data.y / 48);
    changeItemZ(dropZ);
  }
  const changeList = (item: ListItemType, id: string, data: DraggableData) => {
    const dropZ = Math.round(data.y / 48);
    const newList = deepCopy(list);
    // update selecting item's z
    const dragZ = item.z;
    newList[id].z = dropZ;
    // update other items' z
    if (dragZ < dropZ) {
      ids.forEach(targetId => {
        const targetItem = list[targetId]
        if (targetId !== id && dragZ < targetItem.z && targetItem.z <= dropZ) {
          newList[targetId] = {...targetItem, z: targetItem.z - 1};
        }
      })
      setList(newList);
    } else if (dragZ > dropZ) {
      ids.forEach(targetId => {
        const targetItem = list[targetId]
        if (targetId !== id && dropZ <= targetItem.z && targetItem.z < dragZ) {
          newList[targetId] = {...targetItem, z: targetItem.z + 1};
        }
      })
      setList(newList);
    }
  }

  return (
    <Box width="100%">
      <List component="nav">
        {/* リアルタイムにカードプレビューの描画を書き換えるならこっち */}
        {/* { ids.map(id => {
          const item = attributes[id] || (shapes ? shapes[id] : null);
          if (!item) return;
          return (
            <Draggable position={{x: 0, y: item.z * 48}} handle=".handle"
              onStart={() => handleDragStart(id)}
              onDrag={(ev: DraggableEvent, data: DraggableData) => changeZExe(data)}
              onStop={() => setDraggingId('')}
              axis="y" bounds={{top: 0, bottom: (ids.length - 1) * 48}}>
              <ItemListItem button key={id} selected={id === selectingId}
                onClick={() => setSelectingId(id)} dragging={id === draggingId}>
                <ListItemIcon className="handle">
                  <DragIndicatorIcon />
                </ListItemIcon>
                <ListItemText primary={item.name} key={item.name} />
              </ItemListItem>
            </Draggable>
          );
        })} */}
        { ids.map(id => {
          const item = list[id];
          if (!item) return undefined;
          return (
            <Draggable position={{x: 0, y: item.z * 48}} handle=".handle"
              onStart={() => handleDragStart(id)}
              onDrag={(ev: DraggableEvent, data: DraggableData) => changeList(item, id, data)}
              onStop={(ev: DraggableEvent, data: DraggableData) => changeZExe(data)}
              axis="y" bounds={{top: 0, bottom: (ids.length - 1) * 48}}>
              <ItemListItem button key={id} selected={id === selectingId}
                dragging={id === draggingId}
                onClick={() => setSelectingId(id)} onDoubleClick={openDetailTab}
              >
                <ListItemIcon className="handle">
                  <DragIndicatorIcon />
                </ListItemIcon>
                <ListItemText primary={item.name} key={item.name} />
              </ItemListItem>
            </Draggable>
          );
        }) }
      </List>
    </Box>
  );
}

export default SelectItemName;
